import React, { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../../firebase';

const FEHLER = {
  'auth/popup-blocked': 'Popup wurde blockiert. Bitte erlaube Popups für diese Seite.',
  'auth/popup-closed-by-user': null,
  'auth/network-request-failed': 'Netzwerkfehler. Bitte überprüfe deine Verbindung.',
};

export default function StepAccount({ onGoogleFertig, onEmailLogin }) {
  const [laden, setLaden] = useState(false);
  const [fehler, setFehler] = useState(null);

  async function mitGoogle() {
    if (laden) return;
    setFehler(null);
    setLaden(true);
    try {
      await signInWithPopup(auth, googleProvider);
      await onGoogleFertig();
    } catch (err) {
      const msg = FEHLER[err.code] !== undefined
        ? FEHLER[err.code]
        : 'Google-Anmeldung fehlgeschlagen. Bitte versuche es erneut.';
      if (msg) setFehler(msg);
    } finally {
      setLaden(false);
    }
  }

  return (
    <div className="ob-step-enter ob-account">
      <div className="ob-account-card">
        <div className="ob-account-card__badge">Fortschritt sichern</div>
        <h3>Dein Profil ist bereit.</h3>
        <p>
          Erstelle jetzt dein kostenloses Konto, damit CVFlow deine Antworten speichert
          und deine Bewerbungen direkt personalisieren kann.
        </p>

        {fehler && <div className="ob-account-error">{fehler}</div>}

        <button
          type="button"
          className="ob-account-google"
          onClick={mitGoogle}
          disabled={laden}
        >
          <img src="https://www.google.com/favicon.ico" alt="" width="18" height="18" />
          {laden ? 'Verbinde Konto...' : 'Mit Google fortfahren'}
        </button>

        <button
          type="button"
          className="ob-account-email"
          onClick={() => onEmailLogin('register')}
          disabled={laden}
        >
          Mit E-Mail registrieren
        </button>

        <button
          type="button"
          className="ob-account-login"
          onClick={() => onEmailLogin('login')}
          disabled={laden}
        >
          Ich habe schon ein Konto
        </button>
      </div>
    </div>
  );
}
